import React, { Fragment, useEffect, useState } from "react";
import { useGenericStore } from "@customHooks/useGenericStore.js";
import Loading from "@genericComponents/Loading.js";
export const LoadWhenTrue = ({ children, fetchStatusName }) => {
  const isLoad = useGenericStore(fetchStatusName);
  if (isLoad) {
    return <Fragment>{children}</Fragment>;
  }
  return <Loading />;
};
export const LoadClientSideOnly = ({ children, whenTrue = () => true }) => {
  const [isDataReady, setIsDataReady] = useState(false);
  useEffect(() => {
    if (!isDataReady && whenTrue()) {
      setIsDataReady(true);
    }
    return () => {};
  }, [isDataReady]);
  return isDataReady ? <Fragment>{children}</Fragment> : <Fragment />;
};
